import React, { useEffect, useRef, useState } from "react"

import { useSelector } from "react-redux"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import { FilterManager } from "../../util/filters/filterManager"
import CustomTableContainer from "../Common/Table/CustomTableContainer"
import NewOTAMessage from "./OTAMessageModal/newOTAMessage"

export default function OTATable() {
  const [processedMessages, setProcessedMessages] = useState([])
  const [curratedDevices, setCurratedDevices] = useState([])
  const otaMessages = useSelector((state) => state.ota.messages)
  const devices = useSelector((state) => state.device.deviceData)
  const releases = useSelector((state) => state.deviceUpdates.allReleases)
  const deviceVersions = useSelector((state) => state.ota.deviceVersions)

  const filterManagerRef = useRef(null)
  if (!filterManagerRef.current) {
    // basheim add in status icon
    filterManagerRef.current = FilterManager.Builder.addFilter(FILTER_TYPE.OTA_MESSAGE.ID, true)
      .addFilter(FILTER_TYPE.OTA_MESSAGE.TYPE, true)
      .addFilter(FILTER_TYPE.OTA_MESSAGE.INDEX, true)
      .addFilter(FILTER_TYPE.DEVICE.ID, false)
      .addFilter(FILTER_TYPE.DEVICE.NAME, true)
      .addFilter(FILTER_TYPE.OTA_MESSAGE.PROVIDER, true)
      .addFilter(FILTER_TYPE.OTA_MESSAGE.STATUS, true)
      .addFilter(FILTER_TYPE.OTA_MESSAGE.CREATED_AT, true)
      .addFilter(FILTER_TYPE.OTA_MESSAGE.MESSAGE, false)
      .build()
  }
  const filterManager = filterManagerRef.current

  useEffect(() => {
    if (otaMessages && devices && deviceVersions) {
      const versionSet = new Set(deviceVersions)
      const newCurrentedDevices = []
      const deviceMap = new Map()
      for (const device of devices) {
        deviceMap.set(device.device_id, device)
        newCurrentedDevices.push({
          id: device.device_id.toString(),
          approved: versionSet.has(device.software_version),
        })
      }
      setCurratedDevices(newCurrentedDevices)

      setProcessedMessages(
        otaMessages.map((message, index) => {
          return {
            ...filterManager.generateDataMap(
              deviceMap.get(message.device_id),
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              message,
            ),
            id: index,
            message,
            no_click: true,
          }
        }),
      )
    }
  }, [otaMessages, devices, deviceVersions, filterManager.generateDataMap])

  return (
    <CustomTableContainer
      defaultOrder="desc"
      defaultOrderHeader={FILTER_TYPE.OTA_MESSAGE.CREATED_AT}
      headers={filterManager.getHeaders()}
      filterManager={filterManager}
      rowData={processedMessages}
      paginationOptions={[5, 10, 25, 50, 100]}
      defaultPaginationOption={25}
      clickAction={() => {}}
      swipeable={true}
      insightsTable={false}
      AdditionalToolbar={<NewOTAMessage allDevices={curratedDevices} allReleases={releases} />}
      UnsavedChangesSnackbar={false}
    />
  )
}
